class cAdminInstitutions {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elInstitutionsTable = $('#institutions-table');
        elInstitutionsTable.click(function (e) { self.institutionsTableClickHandler(e); });
    }

    institutionsTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);
        console.log($(target));
        if ($(target).hasClass('del')) {
            this.onInstitutionsDelClick(row, e);
        }
    }

    onInstitutionsDelClick(row, e) {

        if (!confirm('WARNING!!! Are you absolutely sure you want to delete this institution? Deleting an entire institution will delete its contacts, statistics and history and is irreversible.')) {
            e.preventDefault();
            return false;
        }
    }

}
